/**
 * The REASON why the Api refused to send a request.
 * MUST match the backend enum: BuilderSendRefusalReasons (BuilderSendRefusedModel.cs)
 */
export enum BuilderSendRefusalReasonEnum {
  /**
   * Fallback for a reason this frontend does not (yet) know
   */
  Unknown = 'Unknown',
  /**
   * You are not allowed to see/send this request (or it does not exist), answered as NotFound
   */
  NoAccess = 'NoAccess',
  /**
   * The documents are still being processed/converted, sending is possible once that is done
   */
  RequestIsProcessing = 'RequestIsProcessing',
  /**
   * The request is no longer a concept, so it is already sent (or withdrawn/completed/expired)
   */
  RequestAlreadySent = 'RequestAlreadySent',
  /**
   * The request is still being build (status New) and is not ready to be sent
   */
  RequestNotReady = 'RequestNotReady',
  /**
   * The complete validation did not pass, the validations are returned with it
   */
  ValidationsFailed = 'ValidationsFailed',
  /**
   * The organisation does not have enough credits to send this request
   */
  InsufficientCredits = 'InsufficientCredits',
}
